import React, { useEffect } from "react";
// import Parse from "parse";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import PropTypes from "prop-types";
import { DashboardLayout } from "./AdminDashboardLayout.styled";
import { getCurrentUserInfo, logoutUser } from "../utils/UserAuth";
import { useDispatch, useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAdminWallet } from "../screens/dashboard/DashboardUtils";
import { saveWalletInfo, setLoadingState } from "../redux/WalletSlice";
import { getCompanyInsuranceInfo } from "../screens/profile/utils";
import { saveCompanyInsuranceInfo } from "../redux/AppSlice";

/* eslint-disable react/prop-types */
function AdminDashboardLayout({ children, data, setData, defaultData }) {
	const { adminWallet } = useSelector((state) => state.wallet);

	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loading, companyInsuranceInfo } = useSelector((state) => state.app);
	const currentAdmin = getCurrentUserInfo();

	function logOutFunc() {
		logoutUser();
		toast.success("You are now logged out of your account.");
	}

	const adminToken =
		currentAdmin?.role?.toLocaleLowerCase() === "logistics"
			? process.env.REACT_APP_LOGISTICS_ADMIN_WALLET_ID
			: process.env.REACT_APP_ADMIN_WALLET_ID;

	const fetchWallet = async () => {
		try {
			const res = await fetchAdminWallet(adminToken);
			const data = { wallet: res?.result?.accounts, otherWalletDetails: res?.result };
			dispatch(saveWalletInfo(data));
		} catch (error) {
			if (error === "This session has expired. Please Login again") {
				navigate("/login");
			} else {
				toast.error(error);
			}
		} finally {
			dispatch(setLoadingState(false));
		}
	};

	const fetchCompanyInfo = async () => {
		setLoadingState(true);
		try {
			const response = await getCompanyInsuranceInfo();

			if (response) {
				dispatch(saveCompanyInsuranceInfo(response));
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoadingState(false);
		}
	};

	useEffect(() => {
		if (adminWallet) {
			return;
		}
		fetchWallet();
	}, [location.pathname]);

	useEffect(() => {
		if (companyInsuranceInfo) {
			return;
		}
		fetchCompanyInfo();
	}, [location.pathname]);

	return (
		<DashboardLayout>
			<Sidebar logOutFunc={logOutFunc} />
			<main className='main'>
				<Navbar data={data} setData={setData} defaultData={defaultData} logOutFunc={logOutFunc} />
				{children}

				{loading && (
					<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</main>
		</DashboardLayout>
	);
}

AdminDashboardLayout.propTypes = {
	children: PropTypes.node,
};

export default AdminDashboardLayout;
